import { useEffect, useState } from "react";
import { CloudOff, Loader2 } from "lucide-react";
import { SERVICE_DOWN_MSG } from "@/lib/api";

const HEALTH_URL = `${process.env.REACT_APP_BACKEND_URL}/api/health`;

export default function ServiceDownBanner() {
  const [down, setDown] = useState(false);

  useEffect(() => {
    const on = () => setDown(true);
    window.addEventListener("bf:service-down", on);
    return () => window.removeEventListener("bf:service-down", on);
  }, []);

  useEffect(() => {
    if (!down) return;
    const t = setInterval(async () => {
      try {
        const r = await fetch(HEALTH_URL, { cache: "no-store" });
        if (r.ok) setDown(false);
      } catch (_) {}
    }, 15000);
    return () => clearInterval(t);
  }, [down]);

  if (!down) return null;
  return (
    <div data-testid="service-down-banner" role="alert"
         className="fixed top-0 inset-x-0 z-[100] bg-amber-500/95 text-black px-4 py-3 flex items-center justify-center gap-3 text-sm font-medium shadow-lg">
      <CloudOff className="w-4 h-4 shrink-0"/>
      <span data-testid="service-down-message">{SERVICE_DOWN_MSG}</span>
      <Loader2 className="w-4 h-4 animate-spin shrink-0 opacity-70"/>
    </div>
  );
}
